import { render, staticRenderFns } from "./MyAddresses.vue?vue&type=template&id=d5f245f6&"
import script from "./MyAddresses.vue?vue&type=script&lang=js&"
export * from "./MyAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports